import { render } from "./ReorderFavorite.vue?vue&type=template&id=0b2915b6&scoped=true"
import script from "./ReorderFavorite.vue?vue&type=script&lang=js"
export * from "./ReorderFavorite.vue?vue&type=script&lang=js"

import "./ReorderFavorite.vue?vue&type=style&index=0&id=0b2915b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2915b6"]])

export default __exports__